(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nx-cod-slot"] && !Shopify.designMode) return;
  try {
    class NxCodSlot extends HTMLElement {
    connectedCallback() {
      this.app = this.querySelector('[data-nx-cod-app]');
      this.fallback = this.querySelector('[data-nx-cod-fallback]');
      if (!this.app || !this.fallback || this.dataset.app === 'none') return;
      const delay = Number(this.dataset.timeout) || 4000;
      this.timer = window.setTimeout(() => this.check(), delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    check() {
      const appRendered = this.app.querySelector('*:not(#_rsi-cod-form-embed-custom-hook)');
      const appButtonElsewhere = document.querySelector('._rsi-buy-now-button, ._rsi-cod-form');
      if (!appRendered && !appButtonElsewhere) {
        this.fallback.hidden = false;
      }
    }
  }

  if (!customElements.get('nx-cod-slot')) customElements.define('nx-cod-slot', NxCodSlot);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nx-delivery-estimate"] && !Shopify.designMode) return;
  try {
    class NxDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      const num = (value, fallback) => {
        const n = parseInt(value, 10);
        return Number.isFinite(n) ? n : fallback;
      };
      this.holidays = new Set((d.holidays || '').split(',').filter(Boolean));
      this.skipSat = d.skipSat === 'true';
      this.skipSun = d.skipSun === 'true';

      const now = this.limaNow();
      let order = now.date;
      if (now.hour >= num(d.cutoff, 24)) order = this.addDays(order, 1);
      const ship = this.addBusinessDays(this.nextBusinessDay(order), num(d.prep, 0));
      const limaMax = num(d.limaMax, 0);
      const limaMin = num(d.limaMin, limaMax);
      const limaFrom = this.addBusinessDays(ship, limaMin);
      const limaTo = this.addBusinessDays(ship, limaMax);

      const fmt = new Intl.DateTimeFormat('es-PE', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
      const f = (date) => fmt.format(date).replace(/\./g, '');
      const range = (a, b) => {
        if (a.getTime() === b.getTime()) return f(a);
        return (d.range || '{inicio} – {fin}').replace('{inicio}', f(a)).replace('{fin}', f(b));
      };

      this.set('order', f(now.date));
      this.set('ship', f(ship));
      this.set('lima', range(limaFrom, limaTo));
      this.set('lima-text', range(limaFrom, limaTo));

      const provMax = num(d.provMax, 0);
      if (provMax > 0) {
        const provMin = num(d.provMin, provMax);
        this.set('prov-text', range(this.addBusinessDays(ship, provMin), this.addBusinessDays(ship, provMax)));
      }
    }

    set(key, text) {
      const el = this.querySelector(`[data-eta="${key}"]`);
      if (el) el.textContent = text;
    }

    limaNow() {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Lima',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          hourCycle: 'h23',
        })
          .formatToParts(new Date())
          .map((p) => [p.type, p.value])
      );
      return {
        date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
        hour: +parts.hour,
      };
    }

    addDays(date, days) {
      const next = new Date(date);
      next.setUTCDate(next.getUTCDate() + days);
      return next;
    }

    isBusinessDay(date) {
      const day = date.getUTCDay();
      if (this.skipSun && day === 0) return false;
      if (this.skipSat && day === 6) return false;
      return !this.holidays.has(date.toISOString().slice(0, 10));
    }

    nextBusinessDay(date) {
      let next = date;
      let guard = 0;
      while (!this.isBusinessDay(next) && guard++ < 30) next = this.addDays(next, 1);
      return next;
    }

    addBusinessDays(date, days) {
      let next = date;
      let left = days;
      let guard = 0;
      while (left > 0 && guard++ < 90) {
        next = this.addDays(next, 1);
        if (this.isBusinessDay(next)) left -= 1;
      }
      return next;
    }
  }

  if (!customElements.get('nx-delivery-estimate')) customElements.define('nx-delivery-estimate', NxDeliveryEstimate);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nx-savings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-variant-live')) {
    customElements.define(
      'nx-variant-live',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section');
          if (!this.section) return;
          this.onSelect = (event) => {
            if (!event.promise || event.target.closest?.('product-card')) return;
            event.promise
              .then(({ detail }) => {
                const next = detail?.html?.querySelector(`[data-nx-live="${this.dataset.nxLive}"]`);
                if (next) this.innerHTML = next.innerHTML;
              })
              .catch(() => {});
          };
          this.section.addEventListener('shopify:product:select', this.onSelect);
        }

        disconnectedCallback() {
          this.section?.removeEventListener('shopify:product:select', this.onSelect);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
